import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  // Lock body scroll while modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-166">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-167">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-navy-light border border-gold/20 rounded-2xl w-full max-w-3xl max-h-[85vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-168">
            {/* Header */}
            <div className="flex items-center justify-between px-5 md:px-8 py-4 md:py-5 border-b border-white/10" data-id="element-169">
              <h2 className="text-xl md:text-2xl font-playfair font-bold text-white" data-id="element-170">
                {title}
              </h2>
              <button onClick={onClose} className="w-9 h-9 rounded-full bg-navy hover:bg-navy/80 border border-white/10 flex items-center justify-center text-gray-light hover:text-white transition-colors" aria-label="Cerrar" data-id="element-171">
                <XIcon className="w-4 h-4" data-id="element-172" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-5 md:px-8 py-5 md:py-6 flex-1" data-id="element-173">
              {children}
            </div>

            {/* Footer */}
            <div className="px-5 md:px-8 py-4 border-t border-white/10 flex justify-end" data-id="element-174">
              <button onClick={onClose} className="bg-gold hover:bg-gold-hover text-navy font-semibold px-5 py-2 rounded-full text-sm transition-colors" data-id="element-175">
                Cerrar
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}